import { DateTime } from 'luxon';

export const useFormatDate = (
  date: string | null | undefined,
  pattern: string = 'M/d/yyyy',
): string => {
  return date ? DateTime.fromISO(date).toFormat(pattern) : '';
};
